import React, { PropsWithChildren } from 'react';
import { Tooltip as MuiTooltip, TooltipProps } from '@material-ui/core';

import Box from '../Box';
import { InfoOutlined } from '../../icons';

type Props = {
  render: React.ReactNode;
  defaultIconRadius?: string | number;
} & Pick<TooltipProps, 'placement' | 'arrow'>;
const ToolTip: React.FC<PropsWithChildren<Props>> = (props: PropsWithChildren<Props>) => {
  const {
    render,
    children,
    placement,
    arrow,
    defaultIconRadius,
  } = props;

  // Convert radius into full height/width
  const formattedDefaultIconRadius = parseFloat(`${defaultIconRadius}`) * 2;
  const tooltipContent = !!children ? children : (
    <InfoOutlined height={formattedDefaultIconRadius} width={formattedDefaultIconRadius} />
  );
  return (
    <MuiTooltip
      arrow={arrow}
      title={render}
      placement={placement || 'bottom'}
    >
      <Box display="inline-flex">
        {tooltipContent}
      </Box>
    </MuiTooltip>
  );
};

export default ToolTip;
